<script lang="ts">
import { createEventDispatcher } from "svelte";


    export let weeks: any[];
    export let selectedMonthNumber: number;
    export let selectedYearNumber: number;
    export let selectedDayNumber: number;
    export let currentDayNumber: number;

    const dispatch = createEventDispatcher();

    const weekdayName = (date: string) => {
		const splittedDate = date.split(".")
		const utcDate = new Date(Date.UTC(Number(splittedDate[2]), Number(splittedDate[1]), Number(splittedDate[0])))
		const weekday = utcDate.toLocaleDateString("default", {weekday: "short"})
		return weekday
	}

    const selectDay = (e) => {
        dispatch("selectDay", {
            day: e.target.innerHTML
        })
    }

</script>

<div class="divide-y divide-gray-200">
    {#each weeks as week}
        <div class="grid grid-cols-7 p-1 divide-x divide-gray-200">
            {#each week.dates as date}
                <div class="{weekdayName(String(date) + "." + String(selectedMonthNumber) + "." + String(selectedYearNumber))} flex p-1 justify-center cursor-pointer {date === selectedDayNumber ? 'bg-blue-200 hover:bg-blue-400' : 'hover:bg-blue-200'} {date === currentDayNumber ? 'bg-gray-200' : ''} {date === currentDayNumber && selectedDayNumber !== currentDayNumber ? 'bg-gray-100' : ''} " on:click="{selectDay}">
                    {date}
                </div>
            {/each}
        </div>
    {/each}
</div>

<style>
	.Mo {grid-column-start: 1;}
	.Di {grid-column-start: 2;}
	.Mi {grid-column-start: 3;}
	.Do {grid-column-start: 4;}
	.Fr {grid-column-start: 5;}
	.Sa {grid-column-start: 6;}
	.So {grid-column-start: 7;}
</style>